import { compose } from 'recompose';
import BlogPostView from './presenter'

export default compose(

)( BlogPostView );